/** 字典类型 */
export enum DictionaryType {
  /** 地域名称  */
  district = 40001000,
  /** 会议目标  */
  meetingObject = 60001000,
  /** 地点类型  */
  addressType = 70001000,
  /** 会议类型  */
  meetingType = 30001000,
  /** 参会人员类型  */
  joinMeetingPersonType = 50001000,
  /** 会议邀请方式  */
  meetingInviteType = 80001000,
  /** 证件类型 */
  credentialsType = 11001000,
}

export enum UserTeamEnum {
  GBA = "GBA",
}

export enum DocumentType {
  ID_CARD = 0,
  CHINESE_PASSPORT = 1,
  HONG_KONG_CHINESE = 2,
  TAI_WAN_CHINESE = 3,
  HONG_KONG = 4,
  TAI_WAN = 5,
  FOREIGN_PASSPORT = 6,
  FOREIGNERS_PERMANENT_RESIDENT_IDENTITY_CARD = 7,
  FOREIGNERS_WORK_PERMIT_A = 8,
  FOREIGNERS_WORK_PERMIT_B = 9,
  FOREIGNERS_WORK_PERMIT_C = 10,
}
